var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5C11.6569 1.5 13 2.84315 13 4.5C13 5.80727 12.1638 6.91925 10.9972 7.33029C10.9258 5.18908 9.50803 3.38892 7.56351 2.74932C8.10814 1.99267 8.99654 1.5 10 1.5Z",
    fill: "#545E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 8.5C10.8127 8.93019 10.6701 9.34032 10.48 9.72268C11.4972 10.0374 12.3755 10.6681 13.0004 11.5H16C16 9.84315 14.6569 8.5 13 8.5H10.9Z",
    fill: "#545E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C9 5.84315 7.65685 4.5 6 4.5C4.34315 4.5 3 5.84315 3 7.5C3 9.15685 4.34315 10.5 6 10.5C7.65685 10.5 9 9.15685 9 7.5Z",
    fill: "#545E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12 12.8431 10.6569 11.5 9 11.5H3C1.34315 11.5 0 12.8431 0 14.5H12Z",
    fill: "#545E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.fa51a9d1dbeb034c51ab6b5b9010ac9e.svg";
export { ForwardRef as ReactComponent };